import React, {useState} from 'react'

import CategorySecondaryPageTitle from '../../components/categorySecondaryPageTitle.js'
import CategoryTechnologies from '../../components/categoryTechnologies.js'

import {CategoryTechnologiesResult} from '../../../../server/routes/technology-type.js'

interface CategoryTechnologiesProps {
	server: string;
	pageData: unknown;
}

export default function CategoryTechnologiesPage({server, pageData}: CategoryTechnologiesProps) {

    const typedPageData = pageData as CategoryTechnologiesResult;
	const [data, setData] = useState(typedPageData);

	return (
        <>
            <CategorySecondaryPageTitle categoryPageHeader={data.CategoryPageHeader}/>
            <section className="section section-sm">
                <div className="container">
                        <CategoryTechnologies 
                            categoryTechnologies={data.CategoryTechnologies}
                        />    
                </div>
            </section>            
        </>
    )
}
